export const MidtransUrl =
  process.env.REACT_APP_FIREBASE_PROD === "YES"
    ? "https://app.midtrans.com/snap/snap.js"
    : "https://app.sandbox.midtrans.com/snap/snap.js";

export const MidtransClientKey =
  process.env.REACT_APP_FIREBASE_PROD === "YES"
    ? "Mid-client-XggALerhK4-hsNUn"
    : "SB-Mid-client-UAf2rnmMXT_1sQqO";
